import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const Page = lazy(() => import('@/modules/posta/SpolecnostForm').then((m) => ({ default: m.SpolecnostForm })));

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/posta/sprava/spolecnosti/nova',
  component: () => <Suspense fallback={null}><Page /></Suspense>,
});
